export class CustomerService {
	id = -100; // -100 magic number for 'N/A'
	desc = 'N/A';

	constructor(init?: CustomerService) {
		Object.assign(this, init);
	}
}
